var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useRef, useState } from 'react';
/* eslint-disable no-restricted-imports */
import { View, Text, ScrollView, StyleSheet, Animated, TouchableOpacity, Clipboard, Alert, } from 'react-native';
import { useAtom } from 'jotai';
import { PanGestureHandler, State } from 'react-native-gesture-handler';
import { apiLogsAtom } from './devToolEventStore';
export const APILoggingBottomSheet = ({ visible, onClose, }) => {
    const [apiLogs, setAPILogs] = useAtom(apiLogsAtom);
    const [expandedLogId, setExpandedLogId] = useState(null);
    const translateX = useRef(new Animated.Value(20)).current;
    const translateY = useRef(new Animated.Value(100)).current;
    // Reset position when modal becomes visible
    React.useEffect(() => {
        if (visible) {
            translateX.setValue(20);
            translateY.setValue(100);
            lastOffset.current = { x: 20, y: 100 };
        }
    }, [visible]);
    const clearLogs = () => {
        setAPILogs([]);
        setExpandedLogId(null);
    };
    const formatTime = (timestamp) => {
        const date = new Date(timestamp);
        return (date.toLocaleTimeString('en-US', {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        }) + `.${date.getMilliseconds().toString().padStart(3, '0')}`);
    };
    const formatJSON = (data) => {
        if (data === null || data === undefined)
            return 'null';
        if (typeof data === 'string')
            return data;
        return JSON.stringify(data, null, 2);
    };
    const getStatusColor = (status, hasError) => {
        if (hasError)
            return '#F44336'; // ERROR - 빨간색
        if (!status)
            return '#9E9E9E'; // PENDING - 회색
        if (status >= 200 && status < 300)
            return '#4CAF50'; // 2xx - 초록색
        if (status >= 300 && status < 400)
            return '#FF9800'; // 3xx - 주황색
        if (status >= 400)
            return '#F44336'; // 4xx, 5xx - 빨간색
        return '#666';
    };
    const getPathFromUrl = (url) => {
        try {
            const urlObj = new URL(url);
            return urlObj.pathname + urlObj.search;
        }
        catch (_a) {
            // URL 파싱에 실패하면 전체 URL에서 도메인 부분만 제거
            return url.replace(/^https?:\/\/[^/]+/, '');
        }
    };
    const toggleExpanded = (logId) => {
        setExpandedLogId(expandedLogId === logId ? null : logId);
    };
    const copyToClipboard = (content, label) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const textToCopy = typeof content === 'string'
                ? content
                : JSON.stringify(content, null, 2);
            yield Clipboard.setString(textToCopy);
            Alert.alert('복사 완료', `${label}가 클립보드에 복사되었습니다.`);
        }
        catch (e) {
            Alert.alert('복사 실패', '클립보드에 복사하는데 실패했습니다.');
        }
    });
    const renderAPILog = (log) => {
        const isExpanded = expandedLogId === log.id;
        return (_jsxs(TouchableOpacity, { style: styles.logItem, onPress: () => toggleExpanded(log.id), children: [_jsxs(View, { style: styles.logHeader, children: [_jsxs(View, { style: styles.logHeaderLeft, children: [_jsx(Text, { style: styles.method, children: log.method }), _jsx(Text, { style: styles.url, numberOfLines: isExpanded ? undefined : 1, children: isExpanded ? log.url : getPathFromUrl(log.url) })] }), _jsxs(View, { style: styles.logHeaderRight, children: [_jsx(Text, { style: [
                                        styles.status,
                                        { color: getStatusColor(log.responseStatus, !!log.error) },
                                    ], children: log.responseStatus || (log.error ? 'ERROR' : 'PENDING') }), _jsx(Text, { style: styles.time, children: formatTime(log.timestamp) }), log.duration && (_jsxs(Text, { style: styles.duration, children: [log.duration, "ms"] }))] })] }), isExpanded && (_jsxs(View, { style: styles.logDetails, children: [log.requestHeaders && (_jsxs(TouchableOpacity, { style: styles.section, onPress: () => copyToClipboard(log.requestHeaders, 'Request Headers'), children: [_jsx(Text, { style: styles.sectionTitle, children: "Request Headers: (\uD130\uCE58\uD574\uC11C \uBCF5\uC0AC)" }), _jsx(Text, { style: styles.jsonText, children: formatJSON(log.requestHeaders) })] })), log.requestBody && (_jsxs(TouchableOpacity, { style: styles.section, onPress: () => copyToClipboard(log.requestBody, 'Request Body'), children: [_jsx(Text, { style: styles.sectionTitle, children: "Request Body: (\uD130\uCE58\uD574\uC11C \uBCF5\uC0AC)" }), _jsx(Text, { style: styles.jsonText, children: formatJSON(log.requestBody) })] })), log.responseHeaders && (_jsxs(TouchableOpacity, { style: styles.section, onPress: () => copyToClipboard(log.responseHeaders, 'Response Headers'), children: [_jsx(Text, { style: styles.sectionTitle, children: "Response Headers: (\uD130\uCE58\uD574\uC11C \uBCF5\uC0AC)" }), _jsx(Text, { style: styles.jsonText, children: formatJSON(log.responseHeaders) })] })), log.responseBody && (_jsxs(TouchableOpacity, { style: styles.section, onPress: () => copyToClipboard(log.responseBody, 'Response Body'), children: [_jsx(Text, { style: styles.sectionTitle, children: "Response Body: (\uD130\uCE58\uD574\uC11C \uBCF5\uC0AC)" }), _jsx(Text, { style: styles.jsonText, children: formatJSON(log.responseBody) })] })), log.error && (_jsxs(TouchableOpacity, { style: styles.section, onPress: () => copyToClipboard(log.error, 'Error'), children: [_jsx(Text, { style: [styles.sectionTitle, { color: '#F44336' }], children: "Error: (\uD130\uCE58\uD574\uC11C \uBCF5\uC0AC)" }), _jsx(Text, { style: [styles.jsonText, { color: '#F44336' }], children: log.error })] }))] }))] }, log.id));
    };
    const lastOffset = useRef({ x: 20, y: 100 });
    const onGestureEvent = Animated.event([{ nativeEvent: { translationX: translateX, translationY: translateY } }], { useNativeDriver: false });
    const onHandlerStateChange = (event) => {
        if (event.nativeEvent.state === State.BEGAN) {
            lastOffset.current = {
                x: translateX._value,
                y: translateY._value,
            };
            translateX.setOffset(lastOffset.current.x);
            translateY.setOffset(lastOffset.current.y);
            translateX.setValue(0);
            translateY.setValue(0);
        }
        else if (event.nativeEvent.state === State.END) {
            translateX.flattenOffset();
            translateY.flattenOffset();
            const finalX = lastOffset.current.x + event.nativeEvent.translationX;
            const finalY = lastOffset.current.y + event.nativeEvent.translationY;
            lastOffset.current = { x: finalX, y: finalY };
        }
    };
    if (!visible)
        return null;
    return (_jsx(View, { style: styles.modalContainer, pointerEvents: "box-none", children: _jsxs(Animated.View, { style: [
                styles.floatingPanel,
                {
                    left: translateX,
                    top: translateY,
                },
            ], children: [_jsx(PanGestureHandler, { onGestureEvent: onGestureEvent, onHandlerStateChange: onHandlerStateChange, shouldCancelWhenOutside: false, activeOffsetX: [-10, 10], activeOffsetY: [-10, 10], children: _jsx(Animated.View, { style: styles.dragHandle, children: _jsx(View, { style: styles.dragIndicator }) }) }), _jsxs(View, { style: styles.header, children: [_jsxs(Text, { style: styles.title, children: ["API Logs (", apiLogs.length, ")"] }), _jsxs(View, { style: styles.headerButtons, children: [_jsx(TouchableOpacity, { onPress: clearLogs, style: styles.clearButton, children: _jsx(Text, { style: styles.clearButtonText, children: "Clear" }) }), _jsx(TouchableOpacity, { onPress: onClose, style: styles.closeButton, children: _jsx(Text, { style: styles.closeButtonText, children: "\u2715" }) })] })] }), _jsx(ScrollView, { style: styles.logsList, showsVerticalScrollIndicator: true, contentContainerStyle: styles.scrollContent, children: apiLogs.length === 0 ? (_jsx(View, { style: styles.emptyState, children: _jsx(Text, { style: styles.emptyStateText, children: "No API calls logged yet" }) })) : (apiLogs.map(renderAPILog)) })] }) }));
};
const styles = StyleSheet.create({
    modalContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
    },
    floatingPanel: {
        position: 'absolute',
        width: 350,
        height: 500,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderRadius: 16,
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 4,
        },
        shadowOpacity: 0.3,
        shadowRadius: 8,
        elevation: 8,
        borderWidth: 1,
        borderColor: 'rgba(0, 0, 0, 0.1)',
    },
    dragHandle: {
        width: '100%',
        height: 32,
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 8,
        paddingBottom: 8,
    },
    dragIndicator: {
        width: 50,
        height: 5,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        borderRadius: 3,
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 16,
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(224, 224, 224, 0.7)',
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#333',
    },
    headerButtons: {
        flexDirection: 'row',
        gap: 12,
    },
    clearButton: {
        paddingHorizontal: 12,
        paddingVertical: 6,
        backgroundColor: '#ff5722',
        borderRadius: 4,
    },
    clearButtonText: {
        color: 'white',
        fontSize: 14,
        fontWeight: '600',
    },
    closeButton: {
        padding: 4,
    },
    closeButtonText: {
        fontSize: 24,
        color: '#666',
    },
    logsList: {
        flex: 1,
        paddingHorizontal: 16,
        paddingTop: 8,
    },
    scrollContent: {
        paddingBottom: 16,
    },
    emptyState: {
        paddingVertical: 40,
        alignItems: 'center',
    },
    emptyStateText: {
        color: '#999',
        fontSize: 14,
    },
    logItem: {
        marginBottom: 8,
        backgroundColor: 'rgba(245, 245, 245, 0.9)',
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'rgba(224, 224, 224, 0.7)',
    },
    logHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 12,
    },
    logHeaderLeft: {
        flex: 1,
        marginRight: 8,
    },
    logHeaderRight: {
        alignItems: 'flex-end',
        minWidth: 80,
    },
    method: {
        fontSize: 12,
        fontWeight: 'bold',
        color: '#2196F3',
        marginBottom: 2,
    },
    url: {
        fontSize: 11,
        color: '#333',
        fontFamily: 'Courier New',
    },
    status: {
        fontSize: 12,
        fontWeight: 'bold',
        marginBottom: 2,
    },
    time: {
        fontSize: 10,
        color: '#666',
        marginBottom: 2,
    },
    duration: {
        fontSize: 10,
        color: '#9C27B0',
        fontWeight: '600',
    },
    logDetails: {
        borderTopWidth: 1,
        borderTopColor: 'rgba(224, 224, 224, 0.7)',
        padding: 12,
    },
    section: {
        marginBottom: 12,
        padding: 8,
        borderRadius: 4,
        backgroundColor: 'rgba(240, 240, 240, 0.5)',
        borderWidth: 1,
        borderColor: 'rgba(200, 200, 200, 0.3)',
    },
    sectionTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        color: '#333',
        marginBottom: 4,
    },
    jsonText: {
        fontSize: 10,
        color: '#333',
        fontFamily: 'Courier New',
        lineHeight: 14,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        padding: 8,
        borderRadius: 4,
        marginTop: 4,
    },
});
